import React from "react";
import Skeleton from "react-loading-skeleton";

const KioskMenuListSkeleton = () => {
  return (
    <div className="row kiosk-row">
      {Array.apply(0, Array(6)).map((n, i) => (
        <div className="col-6" key={i} style={{ marginBottom: "24px", lineHeight: 1 }} >
          <Skeleton height={222} />
        </div>
      ))}
    </div>
  );
};

export default KioskMenuListSkeleton;
